import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 939.000000 940.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,940.000000) scale(0.100000,-0.100000)">

<path d="M4023 9383 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M4156 9375 c8 -19 74 -21 93 -2 10 10 12 9 9 -3 -2 -11 -23 -16 -78
-21 l-75 -5 90 -3 c50 -1 83 -5 75 -8 -8 -3 -29 -20 -46 -38 -17 -17 -38 -34
-47 -38 -10 -4 -17 -15 -17 -26 0 -11 -9 -22 -19 -26 -11 -3 -23 -15 -26 -26
-4 -10 -13 -19 -21 -19 -8 0 -14 -6 -14 -14 0 -8 -9 -18 -20 -21 -20 -6 -22
-10 -24 -55 -1 -18 -9 -26 -34 -34 -26 -7 -35 -16 -39 -39 -4 -17 -14 -32 -25
-34 -10 -3 -18 -14 -18 -24 0 -12 -7 -19 -20 -19 -12 0 -20 -7 -20 -16 0 -9
-9 -18 -20 -21 -13 -3 -20 -14 -20 -28 0 -19 -7 -24 -40 -30 -38 -6 -57 -25
-25 -25 8 0 15 -4 15 -10 0 -5 -4 -10 -10 -10 -5 0 -26 -16 -46 -35 -19 -19
-40 -35 -45 -35 -5 0 -9 -5 -9 -11 0 -13 -42 -68 -87 -113 -18 -18 -33 -40
-33 -49 0 -9 -6 -17 -13 -17 -22 0 -56 -43 -63 -79 -5 -24 -14 -36 -35 -43
-16 -5 -29 -16 -29 -24 0 -8 -4 -14 -9 -14 -5 0 -11 -9 -14 -20 -3 -14 -14
-20 -31 -20 -19 0 -26 -5 -26 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -7 -10 -16 0
-9 -9 -18 -20 -21 -11 -3 -20 -14 -20 -24 0 -12 -7 -19 -19 -19 -10 0 -21 -9
-24 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 -8 -16 -20 0 -11 -4 -20 -10 -20 -5
0 -10 -7 -10 -15 0 -8 -25 -39 -55 -70 -30 -30 -55 -59 -55 -65 0 -5 -7 -10
-15 -10 -8 0 -15 -6 -15 -14 0 -8 -9 -17 -19 -21 -11 -3 -23 -15 -26 -26 -4
-10 -13 -19 -21 -19 -8 0 -14 -7 -14 -15 0 -8 -4 -15 -9 -15 -21 0 -41 -32
-35 -56 5 -21 1 -26 -25 -35 -17 -6 -31 -17 -31 -25 0 -8 -4 -14 -9 -14 -5 0
-11 -9 -14 -20 -3 -12 -14 -20 -27 -20 -13 0 -24 -8 -27 -20 -3 -11 -9 -20
-13 -20 -4 0 -10 -9 -13 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 -8 -16 -20 0
-13 -7 -20 -20 -20 -12 0 -20 -7 -20 -16 0 -9 -9 -18 -20 -21 -11 -3 -20 -14
-20 -24 0 -11 -4 -19 -10 -19 -5 0 -10 -7 -10 -15 0 -8 -31 -45 -70 -81 -38
-37 -70 -73 -70 -80 0 -7 -9 -15 -19 -19 -11 -3 -23 -15 -26 -26 -4 -10 -13
-19 -21 -19 -8 0 -14 -6 -14 -14 0 -8 -9 -18 -20 -21 -20 -6 -22 -10 -24 -55
-1 -18 -9 -26 -34 -34 -24 -7 -34 -17 -40 -40 -6 -23 -16 -33 -41 -40 -25 -7
-34 -16 -38 -39 -4 -17 -14 -32 -25 -34 -10 -3 -18 -14 -18 -24 0 -12 -7 -19
-19 -19 -10 0 -21 -9 -24 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 -7 -16 -16 0
-8 -22 -37 -50 -64 -27 -27 -50 -53 -50 -59 0 -6 -13 -24 -30 -39 -16 -16 -30
-34 -30 -40 0 -6 -9 -13 -19 -17 -11 -3 -23 -15 -26 -26 -4 -10 -13 -19 -21
-19 -8 0 -14 -6 -14 -14 0 -8 -9 -17 -20 -21 -12 -4 -24 -21 -30 -46 -8 -28
-17 -40 -34 -45 -13 -3 -32 -21 -43 -42 -12 -23 -27 -38 -41 -40 -16 -3 -25
-12 -29 -34 -4 -18 -14 -33 -25 -35 -10 -3 -18 -14 -18 -24 0 -12 -7 -19 -19
-19 -10 0 -21 -9 -24 -20 -3 -11 -12 -20 -21 -20 -9 0 -16 -8 -16 -20 0 -11
-7 -20 -15 -20 -8 0 -15 -6 -15 -13 0 -8 -11 -19 -25 -25 -14 -6 -25 -18 -25
-27 0 -8 -4 -15 -10 -15 -5 0 -10 -7 -10 -15 0 -8 -13 -28 -30 -43 -16 -16
-30 -34 -30 -40 0 -6 -9 -13 -19 -17 -11 -3 -23 -15 -26 -26 -4 -10 -13 -19
-21 -19 -8 0 -14 -6 -14 -14 0 -8 -9 -18 -20 -21 -11 -3 -22 -18 -26 -33 -8
-41 -19 -57 -42 -60 -15 -2 -24 -14 -30 -35 -6 -24 -16 -34 -41 -41 -25 -7
-34 -16 -38 -39 -4 -17 -14 -32 -25 -34 -10 -3 -18 -14 -18 -24 0 -12 -7 -19
-20 -19 -12 0 -20 -7 -20 -16 0 -9 -9 -18 -20 -21 -11 -3 -20 -14 -20 -24 0
-11 -7 -19 -15 -19 -8 0 -15 -6 -15 -13 0 -8 -11 -19 -25 -25 -14 -6 -25 -18
-25 -27 0 -8 -4 -15 -10 -15 -5 0 -10 -7 -10 -15 0 -8 -13 -28 -30 -43 -16
-16 -30 -34 -30 -40 0 -6 -9 -13 -19 -17 -11 -3 -23 -15 -26 -26 -4 -10 -13
-19 -21 -19 -8 0 -14 -6 -14 -14 0 -8 -9 -17 -19 -21 -11 -3 -23 -15 -26 -26
-4 -10 -13 -19 -21 -19 -8 0 -14 -6 -14 -14 0 -8 -9 -18 -20 -21 -20 -6 -22
-10 -24 -55 -1 -18 -9 -26 -34 -34 -26 -7 -35 -16 -39 -39 -4 -17 -14 -32 -25
-34 -10 -3 -18 -14 -18 -24 0 -12 -7 -19 -19 -19 -10 0 -21 -9 -24 -20 -3 -11
-12 -20 -21 -20 -10 0 -16 -9 -16 -25 0 -18 -5 -25 -20 -25 -11 0 -20 -5 -20
-10 0 -6 -14 -24 -30 -40 -17 -16 -30 -34 -30 -39 0 -6 -25 -35 -55 -66 -30
-30 -55 -59 -55 -65 0 -5 -4 -10 -10 -10 -14 0 -60 -49 -60 -65 0 -8 -7 -15
-15 -15 -12 0 -15 13 -15 61 0 40 -4 58 -11 54 -6 -4 -7 -19 -4 -36 9 -39 -5
-145 -16 -128 -6 10 -9 8 -9 -9 0 -14 -5 -22 -12 -20 -9 3 -15 42 -18 129 -3
68 -7 -659 -8 -1617 -2 -1919 -5 -1817 60 -2024 156 -493 561 -857 1081 -972
l102 -23 3445 0 3445 0 105 23 c276 61 514 191 716 392 206 205 346 470 401
760 17 90 18 257 18 3500 0 3270 -1 3409 -19 3510 -51 290 -176 536 -383 751
-203 210 -442 345 -728 411 l-100 22 -2002 3 c-1788 3 -2002 2 -1997 -12z
m247 -22 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m27 -861
c14 -7 42 -39 63 -71 l37 -58 -2 -1559 c-3 -1467 -4 -1561 -21 -1591 -25 -46
-55 -72 -99 -84 -90 -24 -65 -45 -651 540 -296 295 -545 548 -553 563 -23 44
-17 90 16 137 58 79 65 81 318 81 l222 0 0 970 c0 1072 -4 1007 64 1049 51 32
96 36 351 36 163 -1 237 -5 255 -13z m680 -18 c36 -17 1051 -1037 1073 -1076
38 -71 9 -152 -68 -192 -36 -19 -62 -22 -252 -26 -116 -3 -215 -9 -220 -13 -4
-5 -8 -441 -8 -970 0 -902 -1 -964 -18 -994 -36 -67 -41 -68 -347 -68 -302 0
-319 3 -357 62 -17 26 -18 117 -21 1578 -2 852 0 1569 3 1593 5 32 16 53 45
82 50 50 104 58 170 24z m-2550 -1144 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3
6 8 10 11 10 2 0 4 -4 4 -10z m-480 -560 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4
10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-265 -320 c3 -5 1 -10 -4 -10 -6 0 -11 5
-11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1788 -1987 c-3 -10 -5 -2 -5 17 0 19
2 27 5 18 2 -10 2 -26 0 -35z m0 -135 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2
-13 2 -33 0 -45z m7778 -38 c134 -18 308 -57 406 -90 111 -37 249 -100 267
-122 10 -13 12 -75 10 -281 -3 -251 -4 -267 -24 -294 -11 -15 -39 -35 -62 -43
-46 -16 -34 -18 -232 53 -123 45 -332 92 -490 112 -253 31 -560 15 -560 -30 0
-29 46 -38 230 -46 374 -17 612 -60 855 -156 234 -92 389 -235 453 -416 31
-89 36 -240 9 -325 -100 -323 -501 -563 -1062 -637 -161 -21 -458 -21 -601 0
-246 37 -520 126 -774 253 -95 47 -138 74 -147 92 -16 32 -18 616 -2 673 14
51 44 77 90 77 38 0 45 -4 201 -118 255 -187 683 -292 1066 -263 76 6 159 16
186 23 48 13 78 39 62 55 -4 4 -141 11 -304 14 -304 7 -393 16 -555 59 -377
99 -646 327 -702 595 -40 191 15 392 143 522 173 176 427 270 832 307 86 7
626 -3 705 -14z m-5161 -32 c8 -13 121 -288 252 -613 130 -324 313 -778 405
-1007 92 -230 171 -433 174 -452 5 -24 1 -48 -13 -79 -35 -79 -25 -78 -484
-75 l-403 3 -65 185 -65 185 -340 0 -340 0 -45 -123 c-52 -143 -89 -194 -164
-227 -49 -22 -63 -23 -426 -28 -206 -2 -385 -1 -397 4 -12 4 -24 17 -28 29
-10 32 836 2066 882 2119 18 22 61 53 95 70 l61 31 443 0 444 0 14 -22z m2128
5 c8 -10 113 -262 234 -560 l219 -542 5 487 5 487 24 42 c14 24 42 55 64 70
l40 28 330 3 c299 3 331 1 348 -14 18 -17 19 -51 19 -1048 0 -982 -1 -1033
-19 -1071 -22 -47 -64 -89 -104 -104 -19 -7 -213 -11 -576 -11 -509 0 -549 1
-563 18 -8 9 -116 258 -239 553 l-224 536 -5 -481 c-3 -264 -9 -490 -14 -501
-19 -43 -59 -86 -96 -105 -37 -19 -59 -20 -368 -20 -242 0 -331 3 -340 12 -9
9 -12 255 -12 1047 0 990 1 1038 19 1077 19 42 65 85 111 103 15 6 239 10 576
10 513 1 552 0 566 -16z"/>
<path d="M7075 4249 c-342 -32 -584 -116 -735 -256 -128 -118 -173 -220 -173
-393 -1 -123 24 -208 88 -304 78 -117 257 -251 425 -315 205 -79 347 -101 710
-109 254 -6 300 -9 322 -24 48 -31 42 -95 -12 -123 -80 -42 -357 -64 -555 -46
-360 34 -658 147 -893 338 -53 43 -88 53 -110 31 -9 -9 -12 -99 -12 -343 l0
-332 148 -71 c259 -126 495 -201 742 -238 161 -23 502 -15 680 16 456 80 806
290 901 539 82 216 14 444 -179 596 -121 96 -329 179 -572 229 -155 31 -273
44 -510 55 -158 7 -191 11 -227 29 -47 24 -58 47 -43 86 52 137 727 95 1178
-74 90 -34 117 -40 139 -33 49 17 53 38 53 299 l0 241 -63 31 c-147 72 -344
128 -557 157 -138 19 -599 28 -745 14z"/>
<path d="M1736 4220 c-47 -15 -106 -61 -131 -104 -13 -23 -78 -174 -145 -336
-67 -162 -252 -609 -411 -993 -159 -383 -289 -700 -289 -702 0 -3 170 -4 378
-3 l378 3 42 27 c56 37 67 57 122 211 l48 132 377 0 377 0 65 -187 65 -188
382 0 c371 0 383 1 404 20 45 43 40 58 -265 814 -157 391 -341 846 -407 1011
l-121 300 -420 2 c-231 1 -433 -2 -449 -7z m492 -1017 l81 -233 -199 0 -199 0
48 138 c123 347 142 398 147 412 7 17 5 22 122 -317z"/>
<path d="M2106 3361 c-9 -14 -116 -321 -116 -332 0 -5 54 -9 123 -9 l123 0
-58 172 c-32 94 -60 173 -62 175 -2 3 -7 0 -10 -6z"/>
<path d="M3340 8425 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M2860 7865 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M2780 7785 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
<path d="M946 5735 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M53 4645 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
